var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef, useMemo } from 'react';
import { faAngleRight, faAngleLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, TextField } from '@mui/material';
import QRCode from 'qrcode';
import ExtensivButton from '../../ExtensivButton';
import MfaOtpInput from '../MfaOtpInput';
import MfaTitleInstruction from '../MfaTitleInstruction';
import { useStyles } from './styles';
export default ({ userEmail, onSetupComplete, getTotpSecretCode, verifyCode, isInitialSetup }) => {
    const { classes } = useStyles();
    const [isQrCode, setIsQrCode] = useState(true);
    const [totpSecret, setTotpSecret] = useState('');
    const [step, setStep] = useState(1);
    const canvasRef = useRef(null);
    useEffect(() => {
        const loadSecret = () => __awaiter(void 0, void 0, void 0, function* () { return setTotpSecret(yield getTotpSecretCode()); });
        loadSecret();
    }, []);
    useEffect(() => {
        if (totpSecret == '' || !isQrCode)
            return;
        QRCode.toCanvas(canvasRef.current, `otpauth://totp/${userEmail}?secret=${totpSecret}&issuer=Extensiv&period=30`, { width: 160, margin: 0 }, (err) => {
            if (!err)
                return;
            console.log('error drawing QR code!', err);
        });
    }, [totpSecret, isQrCode, canvasRef.current]);
    const chunkedSecret = useMemo(() => {
        if (totpSecret == '')
            return '';
        return totpSecret.split('')
            .reduce((acc, char, i) => {
            if (i % 4 == 0) {
                acc.push(char);
            }
            else {
                acc[acc.length - 1] += char;
            }
            return acc;
        }, [])
            .join(' ');
    }, [totpSecret]);
    const getMfaInstruction = () => {
        if (step == 2)
            return 'Enter the code from your authenticator app';
        if (isQrCode)
            return 'Scan the QR code with your authenticator app';
        return 'Enter the setup key in your authenticator app';
    };
    const onCodeEntered = (otpCode, callback) => verifyCode(otpCode, () => {
        onSetupComplete();
        callback(true);
    }, () => callback(false), isInitialSetup);
    return (_jsxs(Grid, Object.assign({ container: true, className: classes.MfaProviderLinkContainer, rowSpacing: 7 }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsx(MfaTitleInstruction, { title: 'Two-factor authentication', instruction: getMfaInstruction() }) })), _jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsxs(Grid, Object.assign({ container: true, rowSpacing: 2 }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12, className: classes.CodeSection }, { children: step == 1 ? (isQrCode
                                ? _jsx("canvas", { ref: canvasRef })
                                : _jsx(TextField, { multiline: true, onFocus: (e) => e.target.select(), className: classes.SecretInput, value: chunkedSecret })) : (_jsx(MfaOtpInput, { onCodeEntered: onCodeEntered })) })), _jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: step == 1 ? (_jsxs(ExtensivButton, Object.assign({ onClick: () => setStep(2), className: classes.StepButton, size: 'large' }, { children: ["Next \u00A0", _jsx(FontAwesomeIcon, { icon: faAngleRight })] }))) : (_jsxs(ExtensivButton, Object.assign({ variant: 'outlined', color: 'secondary', onClick: () => setStep(1), className: classes.StepButton, size: 'large' }, { children: [_jsx(FontAwesomeIcon, { icon: faAngleLeft }), "\u00A0 Back"] }))) })), step == 1 && (_jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsx(ExtensivButton, Object.assign({ variant: 'outlined', color: 'secondary', onClick: () => setIsQrCode(!isQrCode), className: classes.ToggleQrButton, size: 'small' }, { children: isQrCode
                                    ? "Can't scan the code?"
                                    : "Show QR code instead" })) })))] })) }))] })));
};
//# sourceMappingURL=index.js.map